__turbopack_context__.v({
  "active": "editor-button-module__NHIj_q__active",
  "darkTheme": "editor-button-module__NHIj_q__darkTheme",
  "root": "editor-button-module__NHIj_q__root",
});
